
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/facility-company/[id]",
      function () {
        return require("private-next-pages/facility-company/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/facility-company/[id]"])
      });
    }
  